export default __webpack_public_path__ + "static/media/smallgoods_cat_disabled.27bdcf10.png";